export const optionsData = [
  {
    heading: "Soak and Shampoo",
    details:
      "A deep clean using hypoallergenic shampoo that leaves a clean scent and a shiny coat.",
    price: '$',
  },
  {
    heading: "Trim it Up",
    details:
      "Sanitary trim, anti-shed brushing, and nail trim after a soak, shampoo, and deep conditioning.",
    price: '$$',
  },
  {
    heading: "New Hair New Me",
    details:
      "Everything included in trim it up, but a more thorough hair cut. Recommended for long hair breads.",
    price: '$$$',
  },
  {
    heading: "Spa Day!",
    details:
      "Deluxe shampoo and condition, trim hair and nails, tooth brushing, and other sanitary measures.",
    price: '$$$$',
  },
];



